import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BookOpen, FileText, Wrench, Users, Settings, ChevronRight } from "lucide-react";
import axios from "axios";
import { API } from "../config";

const iconMap = { wrench: Wrench, users: Users, settings: Settings, "file-text": FileText, tool: Wrench, default: BookOpen };
const getIcon = (name) => iconMap[name] || iconMap.default;

const PublicManualsPage = () => {
  const [manuals, setManuals] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API}/manuals/public`)
      .then(res => setManuals(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-lojack-black" data-testid="public-manuals-page">
      {/* Header */}
      <div className="bg-gradient-to-b from-[#1A1A1A] to-lojack-black border-b border-gray-800">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8 sm:py-12 text-center">
          <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-2xl bg-lojack-red/10 border border-lojack-red/30 flex items-center justify-center mx-auto mb-4 sm:mb-5">
            <BookOpen size={24} className="text-lojack-red" />
          </div>
          <h1 className="text-2xl sm:text-3xl font-bold text-white mb-2 sm:mb-3" data-testid="public-manuals-title">
            Libreria Manuali
          </h1>
          <p className="text-gray-400 text-sm sm:text-base max-w-xl mx-auto">
            Documentazione tecnica e guide operative LoJack Tracker
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-6 sm:py-10">
        {loading ? (
          <div className="flex justify-center py-16"><div className="spinner" /></div>
        ) : manuals.length === 0 ? (
          <div className="text-center py-16">
            <BookOpen size={48} className="text-gray-700 mx-auto mb-4" />
            <p className="text-gray-500 text-lg">Nessun manuale disponibile al momento.</p>
          </div>
        ) : (
          <div className="grid gap-4 sm:grid-cols-2">
            {manuals.map(m => {
              const Icon = getIcon(m.icon);
              return (
                <div
                  key={m.id}
                  onClick={() => navigate(`/manuali/${m.id}`)}
                  className="bg-[#111] border border-gray-800 rounded-xl sm:rounded-2xl p-4 sm:p-6 cursor-pointer hover:border-gray-600 hover:bg-[#151515] transition-all group"
                  data-testid={`public-manual-card-${m.id}`}
                >
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-xl bg-lojack-red/10 border border-lojack-red/30 flex items-center justify-center flex-shrink-0">
                      <Icon size={22} className="text-lojack-red" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="text-white font-bold text-lg mb-1 group-hover:text-lojack-red transition-colors">{m.title}</h3>
                      <p className="text-gray-500 text-sm line-clamp-2">{m.description}</p>
                    </div>
                    <ChevronRight size={20} className="text-gray-600 group-hover:text-lojack-red transition-colors flex-shrink-0 mt-1" />
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="max-w-5xl mx-auto px-6 pb-10 text-center">
        <p className="text-gray-700 text-xs">&copy; {new Date().getFullYear()} LoJack Italia S.r.l. / CalAmp Corp.</p>
      </div>
    </div>
  );
};

export default PublicManualsPage;
